<div class="row m-0">
    <div class="col-md-12 p-0">
        <div class="form-group row">
            <div class="col-2" style="padding-right:5px">
                <label class="font-weight-bold">Bắt đầu:</label>
                <input
                        class="form-control"
                        #repeatStart="bsDatepicker"
                        bsDatepicker
                        [bsConfig]="{ dateInputFormat: dateFormat }"
                        (ngModelChange)="changeDateStart($event)"
                        [(ngModel)]="start">
<!--                <div (click)="repeatStart.toggle()" class="input-group-append">-->
<!--                    <i class="fa fa-calendar input-group-text"></i>-->
<!--                </div>-->
            </div>
            <div  class="col-2" style="padding-right:5px;padding-left:5px">
                <label class="font-weight-bold">Kết thúc :</label>
                <input
                        class="form-control"
                        #repeatUntil="bsDatepicker"
                        bsDatepicker
                        [bsConfig]="{ dateInputFormat: dateFormat }"
                        (ngModelChange)="changeDateUntil($event)"
                        [(ngModel)]="until">
<!--                <div (click)="repeatUntil.toggle()" class="input-group-append">-->
<!--                    <i class="fa fa-calendar input-group-text"></i>-->
<!--                </div>-->
            </div>
            <div class="col-2" style="padding-left:5px">
                <label class="font-weight-bold">Lặp lịch</label>
                <select [(ngModel)]="rrmode" class="form-control" (change)="changeRepeatTypes($event)" >
                    <option *ngFor="let item of repeatTypes" [value]="item?.value">{{ item?.label }}</option>
                </select>
            </div>
            <div class="col pl-0 pr-0 mt-4 d-flex align-items-center">
                <div *ngIf="rrmode === 'WEEKLY'" class="form-group" style="margin-bottom: 0;">
                    <div class="check-box-i">
                        <div *ngFor="let day of weekDays"
                             [title]="day?.title"
                             (click)="changeWeekDay(day)"
                             [ngClass]="{'check-box-active':day.checked}"
                             class="check-box-item">{{ day?.label }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

